import type { DraftStateUpdater } from 'utils/react/StateProxy';
import type { Delivery, WebHookId, WebHooksState } from '../WebHooksState';

export interface CreateOrUpdateDelivery {
  deliveries: Delivery[];
  webhookId: WebHookId;
}

export const makeCreateOrUpdateDelivery =
  (
    getState: () => WebHooksState,
    updateState: DraftStateUpdater<WebHooksState>,
  ) =>
  ({ deliveries, webhookId }: CreateOrUpdateDelivery): void => {
    const { recentDeliveries } = getState();
    if (recentDeliveries) {
      const newDeliveries = Array.from(recentDeliveries);

      for (const delivery of deliveries) {
        if (delivery.vWebhookSettingsId.includes(webhookId)) {
          const deliveryIndex = recentDeliveries.findIndex(
            ({ id }) => id === delivery.id,
          );

          if (deliveryIndex === -1) {
            newDeliveries.unshift(delivery);
          } else {
            newDeliveries[deliveryIndex] = delivery;
          }
        }
      }

      updateState((draft) => {
        draft.recentDeliveries = newDeliveries;
      });
    }
  };
